<form   [formGroup]="form" novalidate  (ngSubmit)="saveData()" style="display: inline-block;width: 100%;height: auto;">
    <div style="width: 100%; float: left; padding-left: 20px;box-sizing: border-box;">
        <div class="card" >
            <div class="card-body upper-header">
                <div class="table-responsive">
                    <h4 class="card-title card_heading">
                        <div class="d-flex bd-highlight">
                            <div class="p-2 flex-fill bd-highlight">Dharmshala Details</div>
                        </div>
                    </h4>
                    <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
                        <li class="wrapper_label">
                            <label>Dharmshala Name</label>
                            <small>{{bookingDetails?.dharmshala_detail?.name || bookingDetails?.dharmshala_id}}</small>
                        </li>

                        <li class="wrapper_label" *ngIf="bookingDetails?.phone_no">
                            <label>Phone Number</label>
                            <small>{{bookingDetails?.phone_no}}</small>
                        </li>
                        <li class="wrapper_label" *ngIf="bookingDetails?.address">
                            <label>Address</label>
                            <small>{{bookingDetails?.address}}</small>
                        </li>
                    </ul>

                    <h4 class="card-title card_heading">
                        <div class="d-flex bd-highlight">
                            <div class="p-2 flex-fill bd-highlight">Visitor Details</div>
                        </div>
                    </h4>
                    <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
                        <li class="wrapper_label">
                            <label>Name</label>
                            <small>{{bookingDetails?.first_name}} {{bookingDetails?.last_name}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Mobile Number</label>
                            <small>{{bookingDetails?.mobile_no}}</small>
                        </li>
                        <!-- <li class="wrapper_label">
                            <label>State</label>
                            <small>{{bookingDetails?.state?.name}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>City</label>
                            <small>{{bookingDetails?.city?.name}}</small>
                        </li> -->
                        <li class="wrapper_label">
                            <label>From Date</label>
                            <small>{{bookingDetails?.from_date}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>To Date</label>
                            <small>{{bookingDetails?.to_date}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Number of Days</label>
                            <small>{{bookingDetails?.no_of_days}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Address</label>
                            <small>{{bookingDetails?.address}}</small>
                        </li>
                    </ul>
                    

                    <ng-container *ngIf="!isCheckedOutStatus()">
                        <h4 class="card-title card_heading">
                            <div class="d-flex bd-highlight">
                                <div class="p-2 flex-fill bd-highlight">Room Distribution</div>
                            </div>
                        </h4>
    
                        <div class="room_distribution_wrap" formArrayName="rooms" *ngIf="bookingDetails && dharmshalaDetail && form.controls.rooms.length > 0">
                            <ul>
                                <ng-container *ngFor="let data of bookingDetails?.booking_rooms; let i = index" [formGroupName]="i" >
                                    <ng-container *ngIf="isPendingStatus()">
                                        <li [formGroupName]="data.dharmshala_room_id" *ngFor="let row of numSequence(data.no_of_rooms); let j = index">
                                          <label>{{getRoomTitle(data?.dharmshala_room_id)?.room_type?.title}}</label>
                                          <ng-container [formGroupName]="j">
                                          <select formControlName="room_id" class="room_sel">
                                              <option [value]="''">Select Room Number</option>
                                              <option [value]="rooms.id" *ngFor="let rooms of getRooms(data?.dharmshala_room_id, i, j)">{{rooms?.room_no}}</option>
                                          </select>
                                          <!-- <select formControlName="no_of_extra_bed" class="room_sel">
                                            <option [value]="0">NO Extra Bed</option>
                                            <option [value]="rooms" *ngFor="let rooms of getExtraRooms(data?.dharmshala_room_id, i, j)">{{rooms}}</option>
                                          </select>
                                          <span *ngIf="form.value.rooms[i][data.dharmshala_room_id][j].no_of_extra_bed">
                                            <label>{{data.dharmshala_room.extra_bed_charges}} x {{form.value.rooms[i][data.dharmshala_room_id][j].no_of_extra_bed}} =
                                            {{data.dharmshala_room.extra_bed_charges * form.value.rooms[i][data.dharmshala_room_id][j].no_of_extra_bed}}rs</label>
                                        </span> -->
                                         </ng-container>
                        

                                        </li>
    
                                    </ng-container>
                                </ng-container>
                                    <ng-container *ngIf="isCheckedInStatus()">
                                        <li class="heading_lbls">
                                            <label>Room Type</label>
                                            <label>Room Number</label>
                                          </li>
                                        <li *ngFor="let row of assignRoomsDetails; let i = index">
                                          <label><b>{{row?.room_detail?.dharamshala_room?.room_type?.type}}</b></label>
                                          <label><b>{{row?.room_detail?.room_no}}</b></label>
                                          <button [disabled]="row?.check_out_date_time"  type="button"  class="btn btn-primary btn-fw"
                                          (click)="checkout(row?.room_detail_id)">Check Out</button>
                                        </li>
    
                                    </ng-container>
                            </ul>
                        </div>

                      <!-- Visitor Details Section -->
                      <ng-container *ngIf="isCheckedInStatus() && bookingDetails?.booking_visitors && bookingDetails.booking_visitors.length > 0">
                        <h4 class="card-title mt-4">
                            <div class="d-flex bd-highlight">
                                <div class="p-2 flex-fill bd-highlight" style="font-size: 20px;">Persons details</div>
                            </div>
                        </h4>
                        
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Full Name</th>
                                    <th>Age</th>
                                    <th>Gender</th>
                                    <th>ID Proof Type</th>
                                    <th>ID Proof Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let visitor of bookingDetails.booking_visitors; let i = index">
                                    <td>
                                        <span>{{i+1}}</span>
                                    </td>
                                    <td>{{visitor.full_name}}</td>
                                    <td>{{visitor.age}}</td>
                                    <td>{{visitor.gender}}</td>
                                    <td>{{getIdProofTypeName(visitor.id_proof_type_id)}}</td>
                                    <td>{{visitor.id_proof_number}}</td>
                                </tr>
                            </tbody>
                        </table>
                      </ng-container>

                      <ng-container *ngIf="!isCheckedInStatus()">
                        <h4 class="card-title mt-4">
                            <div class="d-flex bd-highlight">
                                <div class="p-2 flex-fill bd-highlight" style="font-size: 20px;">Add Persons details</div>
                            </div>
                        </h4>
                        
                        <ng-container formArrayName="visitors_basic_details" *ngIf="bookingDetails && dharmshalaDetail">
                          <div class="form-group col-12-div visitor_info" *ngFor="let visitor of form.controls['visitors_basic_details']['controls']; let i=index">
                            <ng-container [formGroupName]="i">
                              <div class="form-group visitor_info_list">
                                <label>Full Name*</label>
                                <input [pattern]="'^[a-zA-Z \-\']+'" class="form-control border-primary" formControlName="full_name" name="full_name" required>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.full_name.touched && !form.controls.visitors_basic_details.controls[i].controls.full_name.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.full_name.errors.pattern">Only Alphabet Allowed</div>
                                </div>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.full_name.touched && !form.controls.visitors_basic_details.controls[i].controls.full_name.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.full_name.errors.required">Full Name is required!</div>
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>Age*</label>
                                <input class="form-control border-primary" type="number" formControlName="age" name="age" required>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.touched && !form.controls.visitors_basic_details.controls[i].controls.age.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.errors.required">Age is required!</div>
                                </div>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.touched && !form.controls.visitors_basic_details.controls[i].controls.age.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.errors.max || form.controls.visitors_basic_details.controls[i].controls.age.errors.min">The age must be a number between 1 and 120</div>
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>Gender*</label>
                                <select class="form-control border-primary" name="gender" formControlName="gender">
                                  <option [value]="''">select</option>
                                  <option [value]="'Male'">Male</option>
                                  <option [value]="'Female'">Female</option>
                                  <option [value]="'Other'">Other</option>
                                </select>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.gender.touched && !form.controls.visitors_basic_details.controls[i].controls.gender.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.gender.errors.required">Gender is required!</div>
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>ID Proof Type*</label>
                                <select class="form-control border-primary" name="id_proof_type_id" formControlName="id_proof_type_id">
                                  <option [value]="''">select</option>
                                  <option [value]="type.id" *ngFor="let type of allIdProofTypes">{{type.name}}</option>
                                </select>
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.touched && !form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.errors.required">ID Proof Type is required!</div>
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>ID Proof Number*</label>
                                <input class="form-control border-primary" type="text" formControlName="id_proof_number" name="id_proof_number">
                                <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_number.touched && !form.controls.visitors_basic_details.controls[i].controls.id_proof_number.valid">
                                  <div class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_number.errors.required">ID Proof Number is required!</div>
                                </div>
                              </div>

                              

                              <!-- <div class="form-group visitor_info_close" style="width: 4%;" *ngIf="i != 0">
                                <i class="fa fa-times remove-icon" aria-hidden="true" (click)="removeVisitor(i)"></i>
                              </div> -->
                            </ng-container>
                          </div>
                        </ng-container>

                        <!-- <div class="form-group col-12-div" *ngIf="bookingDetails && dharmshalaDetail">
                          <button type="button" class="btn btn-inverse-primary btn-fw" (click)="addVisitor()">
                            <i class="fa fa-plus"></i> Add Visitor
                          </button>
                        </div> -->
                        </ng-container>
                        
                        
                        ​<div class="button-wrap" *ngIf="!addPayment">
                            <button *ngIf="bookingDetails?.status != 'Checked-In'" type="submit" [disabled]="!form.valid" class="btn btn-primary btn-fw mr-2">Submit</button>
                            <button *ngIf="isCheckedInStatus()"  type="button"  class="btn btn-primary btn-fw"
                            (click)="checkout()">Booking Check Out</button>
                        </div>
                    </ng-container>

                    <form   [formGroup]="paymentForm" *ngIf = "addPayment">
                    <ng-container >
                        <h4 class="card-title card_heading">
                            <div class="d-flex bd-highlight">
                                <div class="p-2 flex-fill bd-highlight">Add Payment Detail</div>
                            </div>
                        </h4>
    
                        <div class="room_distribution_wrap" >
                            <div>
                                <label *ngIf="extra_bed_charge > 0" class="total_charge"><span style="color: red;">*</span>Total Charges Of Extra Bed Is <span>{{extra_bed_charge}} rs</span></label>
                            </div>
                            <div class="form-group col-4-div">
                                <label >Payment Mode*</label>
                                <select class="form-control border-primary" (change)="onPaymentModeChange()"  formControlName="payment_type_id" name="payment_type_id">
                                  <option [value]="''">select</option>
                                  <ng-container *ngFor="let data of allPaymentTypes">
                                    <option [value]="data.id">{{data.type}}</option>
                                  </ng-container>
                                </select>
                                <div class="" *ngIf="paymentForm.controls.payment_type_id.touched && !paymentForm.controls.payment_type_id.valid">
                                  <div  class="inaild_no" *ngIf="paymentForm.controls.payment_type_id.errors.required">Payment Mode is required!</div>
                                </div>
                              </div>
                          
                              <div class="form-group col-4-div" *ngIf="paymentForm.controls.payment_type_id.value != '3'">
                                <label >Transaction No. / Receipt No.*</label>
                                <input type="text" class="form-control border-primary" formControlName="trx_id" name="trx_id">
                                <div class="" *ngIf="paymentForm.controls.trx_id.touched && !paymentForm.controls.trx_id.valid">
                                  <div  class="inaild_no" *ngIf="paymentForm.controls.trx_id.errors.required">Transaction No. / Receipt No. is required!</div>
                                </div>
                              </div>
                        </div>
                        <div class="room_distribution_wrap" >
                              <div class="form-group col-4-div" *ngIf="paymentForm.controls.payment_type_id.value == '3'">
                                <label >Payment Gateway*</label>
                                <select class="form-control border-primary"  formControlName="payment_gateway_id" name="payment_gateway_id" >
                                  <option [value]="''">select</option>
                                  <option *ngFor="let data of allPaymentGateways" [value]="data.id">{{data.name}}</option>
                                </select>
                                <div class="" *ngIf="form?.controls?.payment_gateway_id?.touched && !form?.controls?.payment_gateway_id?.valid">
                                  <div class="inaild_no" *ngIf=" form?.controls?.payment_gateway_id?.errors?.required">Payment Gateway is
                                    required!</div>
                                </div>
                              </div>
                        </div>
                        
                        
                        ​<div class="button-wrap">
                            <button  *ngIf="addPayment" type="submit" (click)="savePaymentFormData()" [disabled]="!paymentForm.valid" class="btn btn-primary btn-fw mr-2">Submit</button>
                     </div>
                    </ng-container>
                    </form>

                    <ng-container *ngIf="bookingDetails?.status == 'Checked-Out' ">
                        <p class="note">Room was checked out by Visitor.</p>
                    </ng-container>
                    
                </div>
            </div>
        </div>
    </div>
</form>
                        
                            
    
<!--        
      ​<div class="button-wrap">
      <button  type="submit" [disabled]="!paymentForm.valid" (click) = "saveDataOfPayment()" class="btn btn-primary btn-fw">Submit</button>

   -->
